export const ORDERS_EXECUTION_REPORT_HEADERS = [
  ['ZLECENIE', '', 'NUMER ZGŁOSZENIA'],
  ['', '', 'DATA WPŁYWU DO RADO'],
  ['', '', 'TERMIN REALIZACJI'],
  ['', '', 'REGION'],
  ['', '', 'STREFA'],
  ['', '', 'ADRES'],
  ['', '', 'GMINA'],
  ['', '', 'ZAKRES ZGŁOSZENIA'],
  ['', '', 'ILOŚĆ /SZT/'],
  ['REALIZACJA', '', 'OPÓŹNIENIE /DNI/'],
  ['', '', 'STATUS ZGŁOSZENIA'],
  ['', '', 'PRZYCZYNA PRZERWANIA'],
  ['', '', 'CZY JEST UMOWA Z ADMINISTRATOREM'],
  ['', '', 'POTWIERDZENIE ODBIORU Z ADMIN'],
  ['ROZLICZENIE', '', 'NUMER PO Z OPL'],
  ['', '', 'ILOŚĆ ELEM. ZDEMONTOWANYCH'],
  ['', '', 'MIESIĄC ROZLICZENIA'],
  'UWAGI',
  'AKTUALIZACJA TERMINU REALIZACJI NA DZIEŃ'
];

export const ORDERS_EXECUTION_REPORT_COLUMN_WIDTHS = [
  24, 26, 17, 20, 20, 50, 25, 60, 15, 15, 25, 25, 15, 15, 20, 15, 15, 40, 20
];

export const CURRENT_DATE_CELL = 'S1';
